import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';

@Component({
  selector: 'app-richtext',
  imports: [NgFor, NgIf, NgClass, StoryblokRichTextDirective],
  templateUrl: './richtext.component.html',
  styleUrl: './richtext.component.scss',
})
export class RichtextComponent {
  @Input() content!: string;
  @Input() align?: string;
  @Input() _editable!: string;
  @Input() display_table: boolean = false;
  @Input() table: {
    thead: { value: string }[];
    tbody: { body: { value: string }[] }[];
  } = {
    thead: [],
    tbody: [],
  };
  @Input() _uid!: string;
  @Input() component!: string;
}
